export default __webpack_public_path__ + "static/media/video.76573978.jpg";